import React from "react";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { ShortLinkModalContainer } from "./ShortLinkModalLUXE-styled";
import { ModalTextParagraph } from "../ModalsLUXE-styled";


interface Props {
  shortLinkModalVisible:boolean,
  shortLink:string,
  setShortLinkModalVisibility:(value)=>void,
}

export default class ShortLinkModal extends React.Component<Props,{}> {
  constructor(props:Props) {
    super(props);
  }

  render = () => {
    const {
      shortLinkModalVisible,
      shortLink,
      setShortLinkModalVisibility
    } = this.props;

    return (
      <ShortLinkModalContainer className="threed-configurator-checkout-modal"
        title="Share your ring!"
        visible={shortLinkModalVisible}
        footer={null}
        onCancel={() => { setShortLinkModalVisibility(false) }}
      >
        {shortLink && 
          <React.Fragment>
            <ModalTextParagraph>
              Your ring configuration has been saved and can be accessed at:
            </ModalTextParagraph>
              
            <ModalTextParagraph> 
              <a id={'short-link-link'} href={shortLink} target={"_blank"} rel={"noopener"}>{shortLink}</a>
            </ModalTextParagraph>
          </React.Fragment>
        }

        {!shortLink &&
    	    <p>
            <Loading3QuartersOutlined
              type="loading-3-quarters"
              spin
            />
            Generating share link...
          </p>
        }
      </ShortLinkModalContainer>
    )
  }
}